import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";

interface FormRadioGroupInputProps {
  name: any;
  label: any;
  options: any[];
  value: any;
  onChange?: (event: any) => void;
  [key: string]: any;
}

const FormRadioGroupInput = ({
  name,
  label,
  options,
  value,
  onChange = () => {},
  ...props
}: FormRadioGroupInputProps) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" id={name}>
        {label}
      </FormLabel>
      <RadioGroup
        aria-labelledby={name}
        name={name}
        value={value}
        onChange={onChange}
        {...props}
      >
        {options.map((el) => {
          return (
            <FormControlLabel
              key={el.id}
              value={el.id}
              control={<Radio />}
              label={el.label}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default FormRadioGroupInput;
